import { useEffect, useState } from 'react';
import {
  useQueryData,
  GetInsightByIdResponse,
  DEFAULT_OVERRIDE_CACHE_TIME,
  useGetInsightById,
} from '@ecolytiq/js-data-provider';

import { RandomInsightById } from 'impactApp/modules/HomePage';

import { useDeps } from 'App/context';

import { useTranslation } from 'react-i18next';

export const useRandomInsightsByIdData = (id: string) => {
  const { httpClientService } = useDeps();

  const [response, setResponse] = useState<Omit<RandomInsightById, 'isLoading'>>({
    randomInsight: {},
  });

  const { i18n } = useTranslation();

  const { randomInsight } = response;
  const { isLoading, isFetching, data, refetch } = useQueryData<{ data: GetInsightByIdResponse }>(
    useGetInsightById(httpClientService, id),
    {
      staleTime: DEFAULT_OVERRIDE_CACHE_TIME,
      cacheTime: DEFAULT_OVERRIDE_CACHE_TIME,
    }
  );

  useEffect(() => {
    if (data?.data) {
      setResponse({
        randomInsight: data.data.randomInsight,
      });
    }
  }, [data, setResponse]);

  useEffect(() => {
    if (i18n.language) refetch();
  }, [refetch, i18n.language]);

  return {
    isLoading: isLoading || isFetching,
    randomInsight,
  };
};
